export default function TrashIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 1.5H11.25V3H6.75V1.5ZM2.25 3.75H15.75V5.25H14.25V15C14.25 15.825 13.575 16.5 12.75 16.5H5.25C4.425 16.5 3.75 15.825 3.75 15V5.25H2.25V3.75ZM12.75 15V5.25H5.25V15H12.75Z"
        fill="currentColor"
      />
    </svg>
  );
}
